<template>
  <div class="application">
    <b-content-header :to="{name: 'ChairmanAdminList'}">
      <span uk-icon="icon: occupant-list; ratio: 1.5" class="shield" style="color: #fff7a8;"></span>
      <span class="content-header--title" v-text="`Председатель ${name}`"></span>
    </b-content-header>
    <WrapperContent>
      <Spinner :isLoading="isLoading">
        <div class="uk-flex uk-flex-between uk-flex-column-reverse@s uk-flex-row@xl">
          <div class="table-wrapper_top">
            <table class="uk-table">
              <tbody>
                <tr>
                  <td class="info-left-col">
                    <span>Фамилия</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      chairman.surname
                    }}</span>
                  </td>
                  <td class="info-left-col">
                    <span>Email</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      chairman.email
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="info-left-col">
                    <span>Отчество</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      chairman.patronymic
                    }}</span>
                  </td>
                  <td class="info-left-col">
                    <span>номер телефона</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      chairman.phone
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="info-left-col">
                    <span>Имя</span>
                  </td>
                  <td>
                    <span class="b-text-semi_bold b-text-color--nero">{{ chairman.name }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="uk-flex uk-flex-center uk-margin-medium-top">
              <b-button name="Редактировать" @click="$modal.show('chairman-form')" />
            </div>
            <div class="remove uk-flex uk-flex-middle">
              <div @click="$modal.show('chairman-confirm')">
                <span uk-icon="icon: close; ratio: 1"></span>
                <span class="uk-margin-small-left">Удалить председателя</span>
              </div>
            </div>
          </div>
        </div>
      </Spinner>
      <ChairmanForm
        :chairmanData="chairman"
        :isEdit="isEdit"
        @update="updateData"
        @save="updateData"
      />
      <b-confirm name="chairman-confirm" @confirm="deleteHandler">
        <span slot="header"> Вы уверены, что хотите удалить председателя {{ name }}? </span>
      </b-confirm>
      <b-table
        ref="tableComponent"
        :header="header"
        :headers="headers"
        :columns="columns"
        :content="communitiesList"
        :uri="uri"
        :sort="'id'"
        class="uk-margin-medium-top"
      />
    </WrapperContent>
  </div>
</template>

<script>
import BContentHeader from '@/components/b-content-header'
import ChairmanForm from './_dialogs/chairman-form'

import {showSuccess} from '@/common/utils/notification'

import {mapActions} from 'vuex'

export default {
  name: 'ChairmanItem',
  components: {
    BContentHeader,
    ChairmanForm
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    errorMessage: '',
    chairman: {},
    uri: '',
    header: '',
    headers: [],
    columns: [],
    communitiesList: [],
    isEdit: true,
    isLoading: false
  }),
  computed: {
    name() {
      return this.chairman.name ? this.chairman.name : '-'
    }
  },
  methods: {
    ...mapActions({
      getChairmanDetails: 'chairman/GET_CHAIRMAN_DETAILS',
      deleteChairman: 'chairman/DELETE_CHAIRMAN'
    }),
    loadChairmanDetails() {
      this.isLoading = true
      this.getChairmanDetails(this.id)
        .then(resp => {
          this.chairman = resp
          this.communitiesList = this.chairman.communities
          this.loadCommunities()
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.chairman = {}
        })
    },
    loadCommunities() {
      this.header = 'Товарищества'
      this.headers = [
        {name: '#', minWidth: 50},
        {name: 'Название ТС', minWidth: 220},
        {name: 'Адрес', minWidth: 220},
        {name: 'Описание', minWidth: 175},
        {name: 'УНП'}
      ]
      this.columns = [
        {name: 'id', type: Number},
        {name: 'name', type: String},
        {name: 'address', type: String},
        {name: 'description', type: String},
        {name: 'unp', type: Number}
      ]
    },
    deleteHandler() {
      this.deleteChairman(this.chairman.id)
        .then(() => {
          showSuccess('Председатель успешно удален')
          this.$router.push({name: 'ChairmanAdminList'})
        })
        .catch(err => {
          this.errorMessage = err
        })
    },
    updateData() {
      this.loadChairmanDetails()
      this.errorMessage = ''
    }
  },
  mounted() {
    this.updateData()
  }
}
</script>
